import React from 'react';
import { ClipboardCheckIcon, LayoutGridIcon, ListOrderedIcon, QuoteIcon, TargetIcon, TimerIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { ctaMicrocopy, plan } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const icons: Record<(typeof plan.features)[number]['icon'], LucideIcon> = {
  goal: TargetIcon,
  timer: TimerIcon,
  steps: ListOrderedIcon,
  questions: LayoutGridIcon,
  quote: QuoteIcon,
  action: ClipboardCheckIcon
};
const numberColors = ['text-sun', 'text-coral', 'text-violet', 'text-white'];
const tiles = ['bg-sun text-ink', 'bg-coral text-white', 'bg-violet text-white', 'bg-white text-brand'];

/** How it works + what every complete class has */
export function SolutionSection() {
  return <section aria-labelledby="plan-title" className="bg-brand py-12 md:py-20" data-id="element-236" data-mp="ktd6uth83lx4">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-237" data-mp="fua1f7xbzdom">
        <SectionHeading id="plan-title" tone="dark" eyebrow={plan.eyebrow} title={plan.title} sub={plan.text} data-id="element-238" data-mp="frntv8afwy6e" />

        <ol className="mt-10 grid grid-cols-2 gap-3 md:mt-12 md:grid-cols-4 md:gap-4" data-id="element-239" data-mp="3b9p7z3klgyac">
          {plan.steps.map((step, i) => <li key={step.title} className="rounded-xl bg-brand-dark p-4 md:p-6" data-id="element-240" data-mp="3fb0x77zk3hi0" data-mpi={i}>
              <span className={`font-display text-[2.6rem] font-black leading-none md:text-[3.2rem] ${numberColors[i % numberColors.length]}`} data-id="element-241" data-mp="3kawrugmd5wkw">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-2 font-display text-[20px] font-black tracking-tight text-white md:text-[22px]" data-id="element-242" data-mp="3u7rosv2znox2">{step.title}</h3>
              <p className="mt-1 text-[14px] leading-snug text-white/80 md:text-[15px]" data-id="element-243" data-mp="2uf88246g55q">{step.text}</p>
            </li>)}
        </ol>

        <h3 className="mt-12 text-center font-display text-[16px] font-black tracking-[0.14em] text-sun" data-id="element-244" data-mp="butvv84m5wce">{plan.featuresTitle}</h3>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-3" data-id="element-245" data-mp="guq1tcwvfxul">
          {plan.features.map((f, i) => {
          const Icon = icons[f.icon];
          return <li key={f.title} className="flex gap-4 rounded-xl bg-brand-dark p-5" data-id="element-246" data-mp="27yht5643nak3" data-mpi={i}>
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${tiles[i % tiles.length]}`} data-id="element-247" data-mp="2mmcpcwhbfx1x">
                  <Icon className="h-5 w-5" strokeWidth={2.25} aria-hidden="true" data-id="element-248" data-mp="2huuvesdpmwqg" />
                </span>
                <div data-id="element-249" data-mp="2vlzp7duecusv">
                  <p className="font-display text-[19px] font-extrabold uppercase leading-snug tracking-tight text-white" data-id="element-250" data-mp="2vlhn40l1zmd1">{f.title}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/80" data-id="element-251" data-mp="35l8h815pbzcl">{f.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 flex max-w-[420px] justify-center md:mt-12" data-id="element-252" data-mp="30kaz1okoz5b3">
          <CtaButton microcopy={ctaMicrocopy} microTone="light" align="center" data-id="element-253" data-mp="1b7zc0lk6v005" />
        </div>
      </div>
    </section>;
}